exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".ameritas .btn-link:hover,.ameritas .btn-link:focus{text-decoration:none}.ameritas .ameritas-secondary-title{color:green;padding:0px !important}.ameritas .ameritas-logo{padding-right:0px}.ameritas .quote-product-name{margin-bottom:0px !important}.ameritas .quoter .quote-card .quote-product-name{padding-top:0px !important}.ameritas .quote-rating-section{padding-top:0px !important}.ameritas .product-information{text-align:left}.ameritas .basic-info-summary{margin-top:0px !important}.ameritas .basic-info-summary .MuiExpansionPanelSummary-content.Mui-expanded{margin:0px !important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./src/components/Quoters/Ameritas/Ameritas.scss
// module id = 7743
// module chunks = 13